var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { DropdownOption } from '../../../classes/definitions/formItem/ElementConfig';
import * as GiftFactory from '../../../classes/definitions/gift/gift';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import Config from '../../../config/config';
import giftSchema from '../../../schemas/giftSchema';
import GiftsService from '../../../services/gifts.service';
import Input from '../../UI/Input/Input';
var GiftForm = /** @class */ (function (_super) {
    __extends(GiftForm, _super);
    function GiftForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.giftsService = new GiftsService(_this.api);
        _this.imageChanged = false; // this will determine if the image has been changed
        // if no changes, no image prop will be sent to the backend
        _this.state = {
            formConfig: _.cloneDeep(giftSchema),
            formIsValid: false,
            discardPopupVisble: false,
        };
        // Setting up the options to all fields that need async data
        // after the options are all set up, then we'll load the data for edit
        _this.setupFieldsOptions = function (data) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            // Setting up the Option Value field based on the parent product
            _this.setStatuses(updatedFormConfig, _.get(data, 'statuses.statuses'));
            console.log(data.statuses.statuses);
            // this.setupOptionValues(updatedFormConfig, _.get(data, 'optionTypes.data'));
            _this.setState({ formConfig: updatedFormConfig }, function () {
                // After setting up the async options
                if (_this.editId !== '-1') {
                    _this.getSample(_this.editId);
                }
            });
        };
        _this.setStatuses = function (updatedFormConfig, rawStatuses) {
            console.log(rawStatuses);
            for (var key in rawStatuses) {
                if (Object.prototype.hasOwnProperty.call(rawStatuses, key)) {
                    updatedFormConfig.status.elementConfig.options.push(new DropdownOption({
                        label: NotosService.formatStatuses(key),
                        value: key,
                    }));
                }
            }
        };
        _this.getSample = function (id) {
            console.log('sending request');
            _this.api
                .getGift(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на метод на плащане';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var sample = GiftFactory.createGift(_.get(data, 'attributes', {}));
            var imageUrl = sample.ImageUrl ? Config.cdnDomain + sample.ImageUrl : null;
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'bg_name.value', sample.BgName);
            _.set(updatedFormConfig, 'bg_name.touched', true);
            _.set(updatedFormConfig, 'bg_name.valid', true);
            _.set(updatedFormConfig, 'en_name.value', sample.EnName);
            _.set(updatedFormConfig, 'en_name.touched', true);
            _.set(updatedFormConfig, 'en_name.valid', true);
            _.set(updatedFormConfig, 'packaging.value', sample.Packaging);
            _.set(updatedFormConfig, 'packaging.touched', true);
            _.set(updatedFormConfig, 'packaging.valid', true);
            _.set(updatedFormConfig, 'brand.value', sample.Brand);
            _.set(updatedFormConfig, 'brand.touched', true);
            _.set(updatedFormConfig, 'brand.valid', true);
            _.set(updatedFormConfig, 'status.value', sample.Status);
            _.set(updatedFormConfig, 'status.touched', true);
            _.set(updatedFormConfig, 'status.valid', true);
            _.set(updatedFormConfig, 'image_url.value', imageUrl);
            _.set(updatedFormConfig, 'image_url.touched', true);
            _.set(updatedFormConfig, 'image_url.valid', true);
            _.set(updatedFormConfig, 'external_id.value', sample.ExternalId);
            _.set(updatedFormConfig, 'external_id.touched', true);
            _.set(updatedFormConfig, 'external_id.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            if (id === 'image_url' && updatedFormElement.valid) {
                _this.imageChanged = true;
            }
            _this.setState({ formConfig: updatedFormConfig, formIsValid: NotosService.checkFormValidity(updatedFormConfig) }, function () {
                console.log(_this.state.formConfig);
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var submittedSample = new FormData();
            var image = _.get(formData, 'image_url.value', null);
            submittedSample.append('gift[bg_name]', _.get(formData, 'bg_name.value', ''));
            submittedSample.append('gift[en_name]', _.get(formData, 'en_name.value', ''));
            submittedSample.append('gift[packaging]', _.get(formData, 'packaging.value', ''));
            submittedSample.append('gift[brand]', _.get(formData, 'brand.value', ''));
            submittedSample.append('gift[status]', _.get(formData, 'status.value', ''));
            // submittedSample.append('sample[position]', _.get(formData, 'position.value', ''));
            submittedSample.append('gift[external_id]', _.get(formData, 'external_id.value', ''));
            if (_this.editId && _this.imageChanged && !image) {
                submittedSample.append('gift[remove_image]', '1');
            }
            else if (_this.editId && _this.imageChanged && image) {
                submittedSample.append('gift[image]', image);
            }
            else if (!_this.editId.length && _this.imageChanged && image) {
                // probably pointless, have to test
                submittedSample.append('gift[image]', image);
            }
            var actionMethod = _this.editId === '-1' ? _this.api.createGift : _this.api.updateGift;
            actionMethod(submittedSample, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.toSamplesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на метод на плащане';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toSamplesPage = function () {
            _this.props.history.push(AppRoutes.gifts.path);
        };
        return _this;
    }
    GiftForm.prototype.componentDidMount = function () {
        var _this = this;
        this.editId = _.get(this.props, 'match.params.giftId', '-1');
        this.giftsService
            .fetchAsyncFieldsOptions()
            .then(function (data) {
            _this.setupFieldsOptions(data);
        })
            .catch(function (error) {
            var defaultMessage = 'Опциите за някое или за всички полета не можаха да бъдат заредени. Опитайте отново!';
            _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
        });
    };
    GiftForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                }, blur: function (event) {
                    return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toSamplesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return GiftForm;
}(React.Component));
// @ts-ignore
export default withRouter(GiftForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Gifts/GiftForm/GiftForm.tsx
// module id = 358
// module chunks = 0